import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation inviteUser($email: String!, $farmId: ID!) {
    inviteUser(email: $email, farmId: $farmId) {
      success
    }
  }
`;

interface InviteUserParams {
  email: string;
  farmId: string;
}

interface Props {
  params: InviteUserParams;
  onCompleted: () => void;
  children: (
    execute: () => void,
    loading: boolean
  ) => React.ReactNode;
}

const handleCompleted = (props: Props, data: any) => {
  console.warn(data);
  props.onCompleted();
};

const InviteUserProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => handleCompleted(props, data)}
    >
      {(mutateFn, result) =>
        props.children(
          () => mutateFn({ variables: props.params }),
          result.loading
        )
      }
    </AuthorizedMutation>
  );
};

export default InviteUserProvider;



// WEBPACK FOOTER //
// ./src/providers/InviteUserProvider.tsx